{
  "v": "5.9.4",
  "fr": 24,
  "ip": 0,
  "op": 48,
  "w": 500,
  "h": 500,
  "nm": "Ziro-Call_Forward_Icon",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Arrow",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0, "y": 1 },
              "o": { "x": 0.521, "y": 0 },
              "t": 0,
              "s": [278.644, 212.95, 0],
              "to": [8.667, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 12,
              "s": [330.644, 212.95, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0, "y": 1 },
              "o": { "x": 0.521, "y": 0 },
              "t": 24,
              "s": [278.644, 212.95, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 36,
              "s": [330.644, 212.95, 0],
              "to": [0, 0, 0],
              "ti": [8.667, 0, 0]
            },
            { "t": 48, "s": [278.644, 212.95, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [48.144, -37.05, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-59.615, -25.983],
                    [35.865, -25.966]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.043121337891, 0.145080566406, 0.152923583984, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [58.298, -32.049], "ix": 2 },
              "a": { "a": 0, "k": [-0.067, -21.032], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Rectangle 2",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.493, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": -7,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [0, -30.584],
                          [30.584, 0],
                          [0, 30.584]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.493, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 5,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-1.25, -23.325],
                          [30.584, 0],
                          [-1.25, 23.325]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.493, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 17,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [0, -30.584],
                          [30.584, 0],
                          [0, 30.584]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.493, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 29,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-1.25, -23.325],
                          [30.584, 0],
                          [-1.25, 23.325]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.493, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 41,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [0, -30.584],
                          [30.584, 0],
                          [0, 30.584]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 53,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-1.25, -23.325],
                          [30.584, 0],
                          [-1.25, 23.325]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "rd",
              "nm": "Round Corners 1",
              "r": { "a": 0, "k": 1, "ix": 1 },
              "ix": 2,
              "mn": "ADBE Vector Filter - RC",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.043121337891, 0.145080566406, 0.152923583984, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [67.37, -37.05], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Rectangle 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 48,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Phone",
      "parent": 3,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "t": 9, "s": [0], "h": 1 },
            { "t": 11, "s": [2], "h": 1 },
            { "t": 13, "s": [-1], "h": 1 },
            { "t": 15, "s": [1], "h": 1 },
            { "t": 17, "s": [-2], "h": 1 },
            { "t": 19, "s": [1], "h": 1 },
            { "t": 21, "s": [0], "h": 1 }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [-12.65, 11.84, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [241.15, 257.74, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            { "t": 9, "s": [100, 100, 100], "h": 1 },
            { "t": 12, "s": [102, 102, 100], "h": 1 },
            { "t": 15, "s": [100, 100, 100], "h": 1 },
            { "t": 18, "s": [102, 102, 100], "h": 1 },
            { "t": 21, "s": [100, 100, 100], "h": 1 }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.118, 0.637],
                    [0.192, 0.288],
                    [3.254, 2.245],
                    [0.673, 0],
                    [0.481, -0.481],
                    [0.288, -0.288],
                    [0.944, -0.069],
                    [2.888, 2.31],
                    [1.848, 1.92],
                    [0.997, 1.984],
                    [-0.216, 0.679],
                    [0, 0],
                    [-0.096, 0.096],
                    [0, 0.481],
                    [0.288, 0.385],
                    [2.595, 1.538],
                    [0.575, -0.503],
                    [0.886, -1.195],
                    [-0.25, -2.845],
                    [-2.291, -4.158],
                    [-2.512, -2.674],
                    [-2.617, -2.013],
                    [-2.933, -0.919],
                    [-0.769, 0.096],
                    [-0.673, 0.481],
                    [-0.326, 0.575]
                  ],
                  "o": [
                    [-0.105, -0.562],
                    [-2.185, -2.791],
                    [-0.354, -0.244],
                    [-0.288, 0],
                    [-0.288, 0.288],
                    [-0.481, 0.481],
                    [-0.944, 0.069],
                    [-0.798, -0.638],
                    [-1.323, -1.375],
                    [-0.32, -0.637],
                    [0.206, -0.649],
                    [2.788, -2.691],
                    [0.288, -0.481],
                    [0, -0.288],
                    [-1.538, -3.172],
                    [-0.288, -0.192],
                    [-0.575, 0.503],
                    [-1.092, 1.472],
                    [0.148, 1.679],
                    [1.521, 2.759],
                    [2.189, 2.329],
                    [2.046, 1.574],
                    [2.933, 0.919],
                    [1.153, -0.192],
                    [0.917, -0.7],
                    [0.326, -0.575]
                  ],
                  "v": [
                    [21.76, 14.92],
                    [21.025, 13.321],
                    [13.036, 5.685],
                    [11.452, 5.101],
                    [9.96, 5.878],
                    [7.077, 8.857],
                    [4.946, 10.149],
                    [0.152, 7.669],
                    [-6.408, 1.36],
                    [-10.207, -3.754],
                    [-10.387, -5.885],
                    [-9.042, -7.423],
                    [-5.966, -10.498],
                    [-5.485, -11.94],
                    [-5.87, -13.382],
                    [-14.759, -21.918],
                    [-16.835, -21.768],
                    [-21.118, -17.442],
                    [-22.06, -11.075],
                    [-19.069, -2.113],
                    [-12.248, 7.304],
                    [-2.593, 16.243],
                    [6.873, 21.299],
                    [14.697, 21.976],
                    [18.123, 20.48],
                    [21.564, 16.805]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2.5, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [247.75, 250.94], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.076, 0.076], "y": [1, 1] },
                    "o": { "x": [0.679, 0.679], "y": [0, 0] },
                    "t": 3,
                    "s": [100, 100]
                  },
                  {
                    "i": { "x": [0.833, 0.833], "y": [0.833, 0.833] },
                    "o": { "x": [0.167, 0.167], "y": [0.167, 0.167] },
                    "t": 13,
                    "s": [120, 120]
                  },
                  {
                    "i": { "x": [0.076, 0.076], "y": [1, 1] },
                    "o": { "x": [0.679, 0.679], "y": [0, 0] },
                    "t": 17,
                    "s": [120, 120]
                  },
                  { "t": 28, "s": [100, 100] }
                ],
                "ix": 3
              },
              "r": { "a": 0, "k": 5, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 48,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "BG",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [249.8, 249.9, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-27.415, 0],
                    [0, -27.415],
                    [27.415, 0],
                    [0, 27.415]
                  ],
                  "o": [
                    [27.415, 0],
                    [0, 27.415],
                    [-27.415, 0],
                    [0, -27.415]
                  ],
                  "v": [
                    [0, -49.64],
                    [49.64, 0],
                    [0, 49.64],
                    [-49.64, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.839215695858, 0.937254905701, 0.952941179276, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 48,
      "st": 0,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": []
}
